const translations = {
    success: {
        loaded: 'Carregado com sucesso',
        wait: 'Extensão carregada com sucesso. Aguarde enquanto buscamos os contatos!',
        connect: 'Banco de dados cadastrado com sucesso'
    },
    error: {},
    warning: {},
    info: {}
};

export default translations;
